import { API } from 'aws-amplify';

const API_NAME_V2 = 'admin-api-v2';

export const getAllSalesLeads = async () => {
  return API.get(API_NAME_V2, '/sales-leads', {});
};

export const createSalesLead = async (data) => {
  return API.post(API_NAME_V2, '/sales-leads', { body: data });
};

export const getSalesLead = async (leadId) => {
  return API.get(API_NAME_V2, `/sales-lead/${leadId}`, {});
};

export const updateSalesLead = async (leadId, data) => {
  return API.put(API_NAME_V2, `/sales-lead/${leadId}`, { body: data });
};

export const deleteSalesLead = async (leadId) => {
  return API.del(API_NAME_V2, `/sales-lead/${leadId}`, {});
};

// Delete a batch of leads. Issues one delete per lead.
export const deleteSalesLeads = async (leadIds) => {
  return Promise.all(leadIds.map((leadId) => deleteSalesLead(leadId)));
};

export const importSalesLeads = async (payload) => {
  return API.post(API_NAME_V2, '/sales-leads/import', { body: payload });
};

// Stamp a batch of leads as printed (Unix seconds). Issues one update per lead.
export const markLeadsPrinted = async (leadIds, printedAt) => {
  return Promise.all(leadIds.map((leadId) => updateSalesLead(leadId, { printedAt })));
};

// Stamp a batch of leads as exported (Unix seconds). Issues one update per lead.
export const markLeadsExported = async (leadIds, exportedAt) => {
  return Promise.all(leadIds.map((leadId) => updateSalesLead(leadId, { exportedAt })));
};
